import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { 
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious 
} from "@/components/ui/carousel";

const galleryImages = [
  {
    src: "/lovable-uploads/8e4614d8-6626-4c0e-a776-520dbd598d82.png",
    alt: "واجهة زجاجية عصرية",
    category: "زجاج"
  },
  {
    src: "/lovable-uploads/435dc714-885d-4a20-99a7-01faffd3c1ad.png",
    alt: "أعمال ألمنيوم متميزة",
    category: "ألمنيوم"
  },
  {
    src: "/lovable-uploads/446e75d8-cedf-4868-b00d-34f03c736054.png",
    alt: "هناجر حديدية",
    category: "حديد"
  },
  {
    src: "/lovable-uploads/56f722da-bf52-4267-86b5-91b9db704f2b.png",
    alt: "ديكورات استانلس ستيل",
    category: "استانلس ستيل"
  },
  {
    src: "/lovable-uploads/61e6df14-89e7-4f12-a903-8761e6ddc560.png",
    alt: "أبواب خشبية فاخرة",
    category: "خشب"
  },
  {
    src: "/lovable-uploads/6f61eeea-613a-4d0f-93ea-337425960036.png",
    alt: "رخام طبيعي",
    category: "رخام"
  }
];

export const Gallery = () => {
  return (
    <section id="gallery" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">
            أعمالنا
          </span>
          <h2 className="text-3xl md:text-4xl font-kufi font-bold text-foreground mb-4">معرض الأعمال</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            نماذج من أعمالنا المميزة في مختلف المجالات الصناعية
          </p>
        </motion.div>

        <div className="max-w-6xl mx-auto">
          <Carousel
            className="relative"
            opts={{
              align: "center",
              loop: true
            }}
          >
            <CarouselContent className="-ml-4">
              {galleryImages.map((image, index) => (
                <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="group"
                  >
                    <div className="relative rounded-2xl overflow-hidden shadow-lg bg-card">
                      <div className="h-72 overflow-hidden">
                        <img 
                          src={image.src} 
                          alt={image.alt}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                          onError={(e) => {
                            e.currentTarget.src = "/placeholder.svg";
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      </div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                        <span className="inline-block bg-primary text-primary-foreground text-sm font-kufi px-3 py-1 rounded-full mb-2">
                          {image.category}
                        </span>
                        <h3 className="font-kufi font-bold text-white">{image.alt}</h3>
                      </div>
                      <div className="p-4 group-hover:opacity-0 transition-opacity duration-300">
                        <span className="inline-block bg-primary/10 text-primary text-sm font-kufi px-3 py-1 rounded-full mb-2">
                          {image.category}
                        </span>
                        <h3 className="font-kufi font-bold text-foreground">{image.alt}</h3>
                      </div>
                    </div>
                  </motion.div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-center gap-4 mt-8">
              <CarouselPrevious className="relative left-0 right-auto translate-y-0 bg-primary text-primary-foreground hover:bg-primary/90" />
              <CarouselNext className="relative right-0 left-auto translate-y-0 bg-primary text-primary-foreground hover:bg-primary/90" />
            </div>
          </Carousel>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <Link to="/gallery">
            <button className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-3 rounded-xl font-bold transition-all duration-300 hover:scale-105 shadow-lg inline-flex items-center gap-3">
              عرض جميع الأعمال
              <ArrowLeft className="h-5 w-5" />
            </button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};